import styled from 'styled-components'
import { ChevronLeftIcon, ChevronRightIcon } from 'icons'
import { sc } from 'utils'

export type Props = {
  numberOfSteps: number
  currentStep: number
  onChange: (step: number) => void
}

export default function Pagination({ numberOfSteps, currentStep, onChange, ...props }: Props) {
  const goToPreviousPage = () => {
    if (currentStep > 1) onChange(currentStep - 1)
  }

  const goToNextPage = () => {
    if (currentStep < numberOfSteps) onChange(currentStep + 1)
  }

  return (
    <Wrapper {...props}>
      <Button disabled={currentStep === 1} onClick={goToPreviousPage}>
        <ChevronLeftIcon />
      </Button>

      {Array.from({ length: numberOfSteps }, (_, index) => (
        <PageIndicator
          key={index}
          current={currentStep === index + 1}
          onClick={() => onChange(index + 1)}
        >
          {index + 1}
        </PageIndicator>
      ))}

      <Button disabled={currentStep === numberOfSteps} onClick={goToNextPage}>
        <ChevronRightIcon />
      </Button>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const PageIndicator = styled.button<{ current: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;

  border-radius: 50%;
  background: ${sc('current', 'var(--green)', 'none')};
  border: none;
  outline: none;

  color: ${sc('current', 'var(--white)', 'var(--text)')};
  font: var(--600-11);
  cursor: pointer;

  transition: background-color 0.2s;

  :hover {
    background: ${sc('current', 'var(--green)', 'var(--green_0-1)')};
  }

  :focus-visible {
    outline: 2px solid var(--green_0-5);
  }
`

const Button = styled.button`
  display: flex;
  padding: 0;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;

  :disabled {
    opacity: 0.5;
  }

  :focus-visible {
    outline: 2px solid var(--green_0-5);
  }
`
